import React from "react";
import { connect } from "react-redux";
import { Button, Popup, SelectBox } from "devextreme-react";
import CardResumen from "../../../../Shared/CardTabs";
import { getMyData, callSucursales, updateMyData } from "../MisDatos/actions";
import helper from "../../../../../helpers/validaciones";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import Moment from "moment";
// setMyData
class MisDatos extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      index: null,
      sucursalvalue: null,
      oldSucursal: null,
      rutEmpresa: null,
      nombre: null,
      seccionUpdate: null,

    };

    this.props.dispatch(getMyData(this.props.UserInfo.RUT));
  }

  onChangeSucursales(e, value) {
    switch (e.element.id) {
      case "sucursalCmbx": {
        this.setState({
          sucursalvalue: value,
        });
        break;
      }
      default:
        break;
    }
  }

  callModalSucursal = (Data) => {
    this.props.dispatch(callSucursales(helper.formatRut(Data.Id.RutEmpresa, { showDots: false, showHyphen: true })));

    this.setState({
      openModal: true,
      index: Data.Id.Id,
      sucursalvalue: Data.Id.Sucursal,
      oldSucursal: Data.Id.Sucursal,
      rutEmpresa: helper.formatRut(Data.Id.RutEmpresa, { showDots: false, showHyphen: true }),
      nombre: Data.Id.NmbEmpresa,
      seccionUpdate: Data.Id.seccionUpdate,
    });
  }

  handleCerrar = () => {
    this.setState({
      openModal: false,
      index: null,
      sucursalvalue: null,
      oldSucursal: null,
      rutEmpresa: null,
      nombre: null,
      seccionUpdate: null,
    });
  }

  handleSave = () => {
    const Company = this.props.profile.Company.length > 0 ? this.props.profile.Company : [];
    const Companies = this.props.profile.Companies.length > 0 ? this.props.profile.Companies : [];
    const {
      profile,
    } = this.props;
    const sucursal = this.props.listadoSucursales.find(s => s.Direccion === this.state.sucursalvalue);

    if (this.state.seccionUpdate === "company") {
      if (Company.length > 0) {
        Company.forEach((item) => {
          if (item.RutEmpresa === this.state.rutEmpresa && item.Nombre === this.state.nombre && item.Sucursal === this.state.oldSucursal) {
            item.Sucursal = this.state.sucursalvalue;
            item.SucursalId = sucursal?.idSucursal;
          }
        });
      }
      profile.Company = Company;
    }
    if (this.state.seccionUpdate === "companies") {
      if (Companies.length > 0) {
        Companies.forEach((item) => {
          if (item.RutEmpresa === this.state.rutEmpresa && item.Nombre === this.state.nombre && item.Sucursal === this.state.oldSucursal) {
            item.Sucursal = this.state.sucursalvalue;
            item.SucursalId = sucursal?.idSucursal;
          }
        });
      }
      profile.Companies = Companies;
    }

    // this.props.dispatch(setMyData(profile));
    this.props.dispatch(updateMyData(profile));
    this.handleCerrar();
  }


  resumenUsuario(profile) {
    const Data = {};
    const userData = [];
    Data.className = "col-12";
    Data.background = "#00B2A9";
    Data.Header = `${profile.Name} ${profile.MiddleName !== null ? profile.MiddleName : ""} ${profile.FatherLastName} ${profile.MotherLastName !== null ? profile.MotherLastName : ""}`;
    Data.LettersCircle = `${helper.getFirstLetter(profile.Name)}${helper.getFirstLetter(profile.FatherLastName)}`;
    Data.Title = `${profile.Name} ${profile.FatherLastName}`;

    const workCompany = [];
    let hasWorkCompany = false;

    if (profile.Company.length > 0) {
      hasWorkCompany = true;
      profile.Company.forEach((item, index) => {
        workCompany.push({
          seccion: [
            {
              label: "Nombre", value: item.Nombre, action: null,
            },
            {
              label: "Rut", value: item.RutEmpresa, action: null,
            },
            {
              label: "Sucursal",
              value: item.Sucursal,
              action: item.Sucursal ? "edit" : "add",
              showSucursal: true,
              Id: {
                Id: index,
                NmbEmpresa: item.Nombre,
                RutEmpresa: item.RutEmpresa,
                Sucursal: item.Sucursal,
                seccionUpdate: "company",
              },
              Btn: {
                id: "BtnSucursal",
                className: "slimButton",
                type: "success",
                onClickMethod: this.callModalSucursal,
                text: "Agregar Sucursal",
              },
            },
          ],
        });
      });
    } else {
      profile.Company.forEach((item, index) => {
        workCompany.push(
          {
            label: "Nombre", value: item.Nombre, action: null,
          },
          {
            label: "Rut", value: item.RutEmpresa, action: null,
          },
          {
            label: "Sucursal",
            value: item.Sucursal,
            action: item.Sucursal ? "edit" : "add",
            showSucursal: true,
            Id: {
              Id: index,
              NmbEmpresa: item.Nombre,
              RutEmpresa: item.RutEmpresa,
              Sucursal: item.Sucursal,
              seccionUpdate: "company",
            },
            Btn: {
              id: "BtnSucursal",
              className: "slimButton",
              type: "success",
              onClickMethod: this.callModalSucursal,
              text: "Agregar Sucursal",
            },
          },
        );
      });
    }

    const manageCompany = [];
    let hasManageCompany = false;
    if (profile.Companies.length > 0) {
      profile.Companies.forEach((item) => {
        manageCompany.push({
          seccion: [
            {
              label: "Nombre", value: item.Nombre, action: null,
            },
            {
              label: "Rut", value: item.RutEmpresa, action: null,
            },
            // {
            //   label: "Sucursal",
            //   value: item.Sucursal,
            //   action: item.Sucursal ? "edit" : "add",
            //   showSucursal: false,
            //   Id: {
            //     Id: index,
            //     NmbEmpresa: item.Nombre,
            //     RutEmpresa: item.RutEmpresa,
            //     Sucursal: item.Sucursal,
            //     seccionUpdate: "companies",
            //   },
            //   Btn: {
            //     id: "BtnSucursal",
            //     className: "slimButton",
            //     type: "success",
            //     onClickMethod: this.callModalSucursal,
            //     text: "Agregar Sucursal",
            //   },
            // },
          ],
        });
      });
    } else {
      profile.Companies.forEach((item, index) => {

        manageCompany.push(
          {
            label: "Nombre", value: item.Nombre, action: null,
          },
          {
            label: "Rut", value: item.RutEmpresa, action: null,
          },
        );
      });
    }

    Data.Tabs = [
      {

        text: "Mi Información",
        tooltipo: { icono: "", text: "" },
        hasSeccion: false,
        idTab: "tab1",
        data: [
          {
            label: "Rut", value: profile.Rut,
          },
          {
            label: "Mail", value: profile.Email,
          },
          {
            label: "Celular", value: profile.CellPhoneNumber,
          },
          {
            label: "Nacimiento", value: profile.BirthDate ? Moment(profile.BirthDate).format("DD/MM/YYYY") : null,
          },
          {
            label: "Mail alternativo", value: profile.AlternativeEmail,
          },
        ],


      },
      {
        text: "Empresas donde trabajo",
        tooltipo: { icono: "?", text: "texto del tooltipo" },
        hasSeccion: hasWorkCompany,
        idTab: "tab2",
        data: workCompany,

      },
    ];
    userData.push(Data);
    return (
      <React.Fragment >
        <CardResumen userData={userData} />
      </React.Fragment >
    );
  }


  render() {
    return (
      <div className="zero row user-card-info">
        <div className="col-12 zero-left card-empresas">
          {this.props.isLoading && <LoadingOverlay />}

          {this.props.profile.Rut != null && this.resumenUsuario(this.props.profile)}


        </div>
        <Popup
          visible={this.state.openModal && !this.props.isLoading}
          dragEnabled={false}
          maxHeight="220px"
          onHiding={this.handleCerrar}
          maxWidth="500px"
          title="Sucursales"
          className="administrar-sucursal-select"
          showTitle
          contentRender={() => (
            <div className="modal-sucursal-select">
              <div className="col-12 center">
                {this.props.listadoSucursales && this.props.listadoSucursales.length === 0 &&
                  <div className="text">
                    <h5> Ha ocurrido un error y/o no se han encontrado sucursales </h5>
                  </div>
                }

                {
                  this.props.listadoSucursales && this.props.listadoSucursales.length > 0 &&
                  <div className="select">
                    <h5>Seleccione la sucursal donde trabaja</h5>
                    <SelectBox
                      id="sucursalCmbx"
                      placeholder="Seleccione .."
                      dataSource={this.props.listadoSucursales}
                      onValueChanged={(data) => this.onChangeSucursales(data, data.value, this.state.index)}
                      displayExpr="Direccion"
                      valueExpr="Direccion"
                      value={this.state.sucursalvalue}
                      searchEnabled
                    />
                  </div>
                }
              </div>

              <div className="button-row">
                <div>
                  <Button
                    text="Cerrar"
                    type="normal"
                    className="cancel"
                    onClick={this.handleCerrar}
                  />
                </div>
                <div>
                  <Button
                    text="Guardar"
                    type="success"
                    className="success"
                    disabled={!!(this.props.listadoSucursales && this.props.listadoSucursales.length === 0)}
                    onClick={this.handleSave}
                  />
                </div>

              </div>
            </div>
          )}
        />

      </div>

    );
  }
}

const mapStateToProps = (state) => ({

  isLoading: state.misDatos.isLoading,
  UserInfo: state.global.userData,
  profile: state.misDatos.profile,
  preventNavigation: state.global.preventNavigation,
  listadoSucursales: state.global.listadoSucursales,

});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(MisDatos);
